export const getObjectKeyValue = function<T extends object, U extends keyof T> (obj: T, key: U): any {
    if (!Object.keys(obj).includes(key.toString())) {
        return null;
    }
    return obj[key];
};


export default getObjectKeyValue;
